import { render, staticRenderFns } from "./FeesAndAwards.vue?vue&type=template&id=5eb407fd&scoped=true&"
import script from "./FeesAndAwards.vue?vue&type=script&lang=js&"
export * from "./FeesAndAwards.vue?vue&type=script&lang=js&"
import style0 from "./FeesAndAwards.vue?vue&type=style&index=0&id=5eb407fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb407fd",
  null
  
)

export default component.exports